export class SpecialRequirement {
  id: string;
  name: string;
}
